import axios from "axios";
import { ENV } from "../config/env";

const attachToken = (config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

// Called on a 401 from our API (expired / logged-out token). Registered in
// index.js so this file doesn't depend on the Redux store.
let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => {
  onUnauthorized = fn;
};

// Called on a 403 with the server's message ("Your role has no access to X").
let onForbidden = null;
export const setForbiddenHandler = (fn) => {
  onForbidden = fn;
};

// Wrong credentials on these routes are a normal 401, not an expired session
const PUBLIC_ROUTES = ["/auth/login", "/users/forgot-password/reset"];

const handleAuthError = (error) => {
  const url = error?.config?.url || "";
  if (
    error?.response?.status === 401 &&
    !PUBLIC_ROUTES.some((r) => url.includes(r))
  ) {
    onUnauthorized?.();
  } else if (error?.response?.status === 403) {
    onForbidden?.(error);
  }
  return Promise.reject(error);
};

const api = axios.create({
  baseURL: ENV.API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});
// console.log(ENV.API_BASE_URL)
api.interceptors.request.use(attachToken);

api.interceptors.response.use((response) => response.data, handleAuthError);

// Client for the Redux slices: same auth token as `api`, but it returns the full
// axios response (so slices keep using `res.data`) and has no default
// Content-Type or timeout, so FormData uploads work as before.
// Third-party APIs (e.g. PSGC, restcountries) should keep using plain axios
// so the token is never sent to them.
export const http = axios.create({
  baseURL: ENV.API_BASE_URL,
});
http.interceptors.request.use(attachToken);
http.interceptors.response.use((response) => response, handleAuthError);

export default api;
